import moment from "moment";

type GenerateFilename = {
  name: string;
  extension: "xlsx" | "pdf" | "kmz";
};

export function generateFilename({ name, extension }: GenerateFilename) {
  const dateNow = moment(new Date()).format("YYYY-MM-DDTHH-mm-ss");
  const filename = `${name}-${dateNow}.${extension}`;

  return filename;
}

export function generateFilenameWithoutMinute({
  name,
  extension,
}: GenerateFilename) {
  const dateNow = moment(new Date()).format("YYYY-MM-DD");
  const filename = `${name}-${dateNow}.${extension}`;

  return filename;
}
